module.exports = __webpack_public_path__ + "static/media/caja_arequipa.65456edb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-order/payment-method/caja_arequipa.png
// module id = 1990
// module chunks = 0